module.exports = __webpack_public_path__ + "static/media/iconMagic.e4a7df9a.svg";